import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import Icon from "./Icon.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FileIcon',
    props: {
        type: {}
    },
    setup(__props) {
        const props = __props;
        function iconName() {
            const icons = {
                'excel': 'file-excel',
                'spreadsheet': 'file-spreadsheet',
                'csv': 'file-csv',
                'word': 'file-word',
                'image': 'file-image',
                'audio': 'file-music',
                'mp3': 'file-music',
                'video': 'file-video',
                'mpeg': 'file-video',
                'json': 'file-code',
                'zip': 'file-archive',
            };
            for (const key in icons) {
                if (icons.hasOwnProperty(key) && props.type.indexOf(key) !== -1) {
                    return icons[key];
                }
            }
            return 'file';
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(Icon, {
                name: iconName(),
                title: __props.type,
                "icon-style": "light"
            }, null, 8, ["name", "title"]));
        };
    }
});
